import { CurrencySetting, Point } from "../../type";

export type AnimationPoint = {
  x: number;
  y: number;
  isIceBreak: boolean;
  isDropdownPoint: boolean;
  groupId: number;
  endId: number;
  win: number;
};

export type SugarBlastGameData = {
  bombCount: number;
  animationPoints?: AnimationPoint[];
  triggeredFeatureSymbolId: FeatureSymbols;
  triggeredFeaturePoint?: Point;
  candyBaySymbolIds?: number[];
  rocketDirection: "None" | "Horizontal" | "Vertical";
};

export enum Symbols {
  StarCake = 201,
  FlowerCookie = 202,
  HeartCandy = 203,
  DiamondSwirlCandy = 204,
  PurpleDonutCandy = 101,
  VioletLollipop = 102,
  BlueTearCandy = 103,
  GreenJellybean = 104,
  GummyRocket = 4,
  ChocolateBomb = 3,
  MysterySweet = 2,
  SugarBlast = 8,
  IceBomb = 7,
  Bomb = 5,
}

export enum FeatureSymbols {
  None = 0,
  IceValue = 1,
  Bomb = 5,
  GummyRocket = 4,
  Chocolate = 3,
  MysterySweet = 2,
  RocketRocket = 44,
  ChocolateChocolate = 33,
  MysterySweetSweet = 22,
  RocketChocolate = 43,
  RocketMysterySweet = 42,
  ChocolateMysterySweet = 32,
  SugarBlast = 8,
  IceBomb = 7,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number };
  buyFreeSpinRate: number;
};
